module.exports = __webpack_public_path__ + "img/avatar_song.03222ecc.png";